// src/components/Categories.js
import React from "react";
import "../styles/categories.css";

const CATEGORIES = [
  {
    name: "Poklon kutije",
    tag: "Za svaku važnu prigodu",
    description:
      "Elegantne kutije za kumove, mladence, bebe, krizme, promocije, djevojačke i mnoge druge trenutke koje želite obilježiti.",
    items: [
      "Vjenčanje",
      "Baby",
      "Krizma",
      "Krsni set",
      "Krštenje",
      "Promocija",
      "Rođendan",
      "Djevojačka & momačka",
      "Wedding box",
    ],
  },
  {
    name: "Zahvalnice",
    tag: "Sitnice koje puno znače",
    description:
      "Personalizirane zahvalnice za vjenčanja, krizme, prvu pričest i krštenja – usklađene s temom vašeg događaja.",
    items: ["Vjenčanje", "Krizma & Prva pričest", "Krštenje"],
  },
  {
    name: "Ostali proizvodi",
    tag: "Detalji koji čine razliku",
    description:
      "Drvene pitalice, reveri, vješalice, ogrtači, majice, prskalice, rupčići, strugalice, pokloni za rođenje, pljoske i još mnogo toga.",
    items: [
      "Drvene pitalice",
      "Reveri",
      "Kutije za darivanje",
      "Ogrtači",
      "Vješalice",
      "Majice",
      "Prskalice",
      "Rupčići",
      "Strugalice",
      "Pokloni za rođenje",
      "Pljoske",
    ],
  },
];

const Categories = () => {
  return (
    <div className="container categories">
      <div className="categories-header fade-in">
        <p className="section-title">Ponuda</p>
        <h2 className="section-heading">Pokloni za sve prigode</h2>
        <p className="section-subtitle">
          Bilo da tražite poklon za kumove, originalan način zahvale gostima ili
          sitnice za uređenje fotografija – KBIA poklon kutije nude kompletno
          rješenje na jednom mjestu.
        </p>
      </div>

      <div className="categories-grid">
        {CATEGORIES.map((cat) => (
          <article key={cat.name} className="category-card fade-in">
            <div className="category-tag">{cat.tag}</div>
            <h3 className="category-title">{cat.name}</h3>
            <p className="category-text">{cat.description}</p>
            <ul className="category-list">
              {cat.items.map((item) => (
                <li key={item} className="category-list-item">
                  <span className="dot" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="categories-webshop-link fade-in">
        <p>
          Više proizvoda možete vidjeti u našoj{" "}
          <a
            href="https://shop.kbia.hr/wp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            TRGOVINI
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Categories;
